import ResourcePattern from '../utils/resource-pattern';

export default ResourcePattern('tipoAgrupamentos');
